import {ArticleCategory} from "../actions/ArticleCategory";
import {getCategoryUrl} from "../utils/get_category_url";

const invest_lg = require("../assets/categories_section/invest_lg.png");
const invest_md = require("../assets/categories_section/invest_md.png");
const law_and_docs_lg = require("../assets/categories_section/law_and_documents_lg.png");
const law_and_docs_md = require("../assets/categories_section/law_and_documents_md.png");
const market_trends_md = require("../assets/categories_section/trendy_rynkowy_md.png");
const market_trends_lg = require("../assets/categories_section/trendy_rynkowe_lg.png");
const credit_and_fiance_md = require("../assets/categories_section/credit_and_finances_md.png");
const credit_and_fiance_lg = require("../assets/categories_section/credit_and_finance_lg.png");
const interviews_md = require("../assets/categories_section/interviews_md.png");
const interviews_lg = require("../assets/categories_section/interviews_lg.png");

export const knowledgeSectionCategories = [
    {
        picture: {md: invest_md, lg: invest_lg},
        url: getCategoryUrl(ArticleCategory.Investments),
        title: "Inwestowanie w nieruchomości",
        bulletPoints: ["Dochód pasywny", "Oferty inwestycyjne", "Lokata kapitału"]
    },
    {
        picture: {md: law_and_docs_md, lg: law_and_docs_lg},
        url: getCategoryUrl(ArticleCategory.Taxes),
        title: "Prawo i dokumenty",
        bulletPoints: ["Obowiązki podatkowe", "Porady prawne", "Ulgi mieszkaniowe"]
    },
    {
        picture: {md: market_trends_md, lg: market_trends_lg},
        url: getCategoryUrl(ArticleCategory.Reports),
        title: "Raporty i dane rynkowe",
        bulletPoints: ["Analizy rynkowe", "Ceny mieszkań", "Raporty"]
    },
    {
        picture: {md: credit_and_fiance_md, lg: credit_and_fiance_lg},
        url: getCategoryUrl(ArticleCategory.Finance),
        title: "Kredyty i finanse",
        bulletPoints: ["Wkład własny", "Poradnik kredytowy", "Zdolność kredytowa"]
    },
    {
        picture: {md: interviews_md, lg: interviews_lg},
        url: getCategoryUrl(ArticleCategory.Interviews),
        title: "Wywiady z ekspertami",
        bulletPoints: ["Edukacja o rynku nieruchomości", "Rozmowy z ekspertami", "Praktyczne porady dla kupujących"]
    }
];
import {ArticleCategory} from "../actions/ArticleCategory";
import {getCategoryUrl} from "../utils/get_category_url";

const invest_lg = require("../assets/categories_section/invest_lg.png");
const invest_md = require("../assets/categories_section/invest_md.png");
const law_and_docs_lg = require("../assets/categories_section/law_and_documents_lg.png");
const law_and_docs_md = require("../assets/categories_section/law_and_documents_md.png");
const market_trends_md = require("../assets/categories_section/trendy_rynkowy_md.png");
const market_trends_lg = require("../assets/categories_section/trendy_rynkowe_lg.png");
const credit_and_fiance_md = require("../assets/categories_section/credit_and_finances_md.png");
const credit_and_fiance_lg = require("../assets/categories_section/credit_and_finance_lg.png");
const interviews_md = require("../assets/categories_section/interviews_md.png");
const interviews_lg = require("../assets/categories_section/interviews_lg.png");

export const knowledgeSectionCategories = [
    {
        picture: {md: invest_md, lg: invest_lg},
        url: getCategoryUrl(ArticleCategory.Investments),
        title: "Inwestowanie w nieruchomości",
        bulletPoints: ["Dochód pasywny", "Oferty inwestycyjne", "Lokata kapitału"]
    },
    {
        picture: {md: law_and_docs_md, lg: law_and_docs_lg},
        url: getCategoryUrl(ArticleCategory.Taxes),
        title: "Prawo i dokumenty",
        bulletPoints: ["Obowiązki podatkowe", "Porady prawne", "Ulgi mieszkaniowe"]
    },
    {
        picture: {md: market_trends_md, lg: market_trends_lg},
        url: getCategoryUrl(ArticleCategory.Reports),
        title: "Raporty i dane rynkowe",
        bulletPoints: ["Analizy rynkowe", "Ceny mieszkań", "Raporty"]
    },
    {
        picture: {md: credit_and_fiance_md, lg: credit_and_fiance_lg},
        url: getCategoryUrl(ArticleCategory.Finance),
        title: "Kredyty i finanse",
        bulletPoints: ["Wkład własny", "Poradnik kredytowy", "Zdolność kredytowa"]
    },
    {
        picture: {md: interviews_md, lg: interviews_lg},
        url: getCategoryUrl(ArticleCategory.Interviews),
        title: "Wywiady z ekspertami",
        bulletPoints: ["Edukacja o rynku nieruchomości", "Rozmowy z ekspertami", "Praktyczne porady dla kupujących"]
    }
];
